import React from 'react';
import { Box, Rating, Typography } from '@mui/material';
import { TutorProfile } from '../../services/interfaces';

interface ProfileStatsProps {
    profile: TutorProfile;
}

const ProfileStats: React.FC<ProfileStatsProps> = ({ profile }) => {
    return (
        <Box sx={{ display: 'flex', alignItems: 'center', mt: 1, mb: 2, pl: { sm: 2 } }}>
            {/* Added padding left to align with text in the grid layout if needed, 
           but since this is usually under the header text, it might need adjustment based on parent grid */}
            <Rating value={profile.rating || 0} readOnly precision={0.5} />
            <Typography variant="body2" color="text.secondary" sx={{ ml: 1 }}>
                ({profile.numReviews || 0} reviews)
            </Typography>
        </Box>
    );
};

export default ProfileStats;
